<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name == 'home') {
        // matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
        this.levelList = [{ path: '/home', meta: { title: '首页' }}];
      } else {
        this.levelList = matched.slice(1);
        if(this.$route.query && this.$route.query.title) {
          if(this.$route.query.ptitle) {
            this.levelList = [{path:this.levelList[0].parent.path,meta:{title: this.levelList[0].parent.meta.title}},{path:"/pms/customer/detail?id="+this.$route.query.id+"&title="+this.$route.query.ptitle,meta:{title: this.$route.query.ptitle}},{path: '/home',redirect:"noredirect",meta:{title: this.$route.meta.title}}]; 
          } else {
            this.levelList = [{path:this.levelList[0].parent.path,meta:{title: this.levelList[0].parent.meta.title}},{path: '/home',redirect:"noredirect",meta:{title: this.$route.query.title}}];
          }
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 12px;
    line-height: 40px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue